import React from "react";
import { motion } from "framer-motion";

const ZIIcon = () => {
    return (
        <motion.div
            className="w-20 h-20 flex items-center justify-center relative bg-gray-900 rounded-full shadow-2xl"
            animate={{ rotate: [0, 10, -10, 0] }}
            transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        >
            {/* Z */}
            <motion.span
                className="absolute text-5xl font-bold text-gradient-to-r from-indigo-500 via-purple-500 to-pink-500"
                animate={{
                    rotate: [0, 5, -5, 0],
                    scale: [1, 1.2, 1],
                    textShadow: [
                        "0 0 5px #fff, 0 0 10px #a855f7",
                        "0 0 10px #fff, 0 0 20px #f472b6",
                        "0 0 5px #fff, 0 0 10px #a855f7",
                    ],
                }}
                transition={{ duration: 2, repeat: Infinity }}
            >
                Z
            </motion.span>

            {/* Inverted slanted I */}
            <motion.span
                className="absolute text-5xl font-bold text-gradient-to-r from-yellow-400 via-red-500 to-pink-500"
                style={{ transform: "rotate(-20deg) scaleY(-1)" }} // inverted and slanted
                animate={{
                    rotate: [-20, -15, -25, -20],
                    scale: [1, 1.1, 1, 1.1],
                    textShadow: [
                        "0 0 5px #fff, 0 0 10px #facc15",
                        "0 0 10px #fff, 0 0 20px #f87171",
                        "0 0 5px #fff, 0 0 10px #facc15",
                    ],
                }}
                transition={{ duration: 2.5, repeat: Infinity }}
            >
                I
            </motion.span>
        </motion.div>
    );
};

export default ZIIcon;
